import React, { useState, useContext, useEffect } from 'react'
import './Header.scss'
import { Button, Tooltip, Row, Col } from 'reactstrap'
import { SPContext } from '../../SPContext'
import { Link } from 'react-router-dom'

const scrollToFilters = () => {
    const target = document.querySelector('.sp-filter')
    const coords = target.getBoundingClientRect()
    if (coords.top > 0) {
        // only do it if the top of section is below the top border of the viewport
        window.scrollTo({
            top: parseInt(coords.top) + parseInt(window.scrollY),
            behavior: 'smooth',
        })
    }
}

const logOut = () => {
    localStorage.removeItem('token')
    window.location.reload()
}

function Header() {
    const [likeTooltipOpen, setLikeTooltipOpen] = useState(false)
    const [goingTooltipOpen, setGoingTooltipOpen] = useState(false)
    const [loginTooltipOpen, setLoginTooltipOpen] = useState(false)
    const [galleryTooltipOpen, setGalleryTooltipOpen] = useState(false)
    const [adminPageTooltipOpen, setAdminPageTooltipOpen] = useState(false)
    const [mainPageTooltipOpen, setMainPageTooltipOpen] = useState(false)

    const {
        handleOpenEventModal,
        gotoGallery,
        setFilter,
        user_id,
        filter,
        isAdmin,
        inAdminPage,
        setInAdminPage,
    } = useContext(SPContext)

    useEffect(() => {})

    const toogleLikeTooltip = () => {
        setLikeTooltipOpen(!likeTooltipOpen)
    }
    const toogleGoingTooltip = () => {
        setGoingTooltipOpen(!goingTooltipOpen)
    }
    const toogleLoginTooltip = () => {
        setLoginTooltipOpen(!loginTooltipOpen)
    }
    const toogleGalleryTooltip = () => {
        setGalleryTooltipOpen(!galleryTooltipOpen)
    }
    const toogleAdminPageTooltip = () => {
        setAdminPageTooltipOpen(!adminPageTooltipOpen)
    }
    const toogleMainPageTooltip = () => {
        setMainPageTooltipOpen(!mainPageTooltipOpen)
    }

    const mainPage = () => {
        setInAdminPage(false)
    }

    const toAdminPage = () => {
        setInAdminPage(true)
    }

    return (
        <section className='sp-header'>
            <div className='container'>
                <Row>
                    <Col xs='5' md='6' className='header-logo pb-4 pb-sm-0'>
                        <Link to={'/'}>
                            <img className='white' src='/images/play-plan.png' alt='plan.com' />
                        </Link>
                    </Col>
                    <Col xs='7' md='6' className='sp-body-header-right sp-no-padding'>
                        {!inAdminPage ? (
                            <React.Fragment>
                                <div
                                    className='btn sp-header-login-out circle-button '
                                    id='sp-login-out'
                                    onClick={logOut}
                                >
                                    <i className='fas fa-sign-out-alt' />
                                </div>
                                <Tooltip
                                    placement='bottom'
                                    isOpen={loginTooltipOpen}
                                    target='sp-login-out'
                                    toggle={toogleLoginTooltip}
                                >
                                    Log out
                                </Tooltip>
                            </React.Fragment>
                        ) : null}

                        {isAdmin && !inAdminPage ? (
                            <React.Fragment>
                                <Link
                                    to={'/admin'}
                                    id='sp-admin-page'
                                    onClick={toAdminPage}
                                    className='btn sp-header-login-out float-right'
                                >
                                    <i className='fas fa-user-secret' />
                                </Link>

                                <Tooltip
                                    placement='bottom'
                                    isOpen={adminPageTooltipOpen}
                                    target='sp-admin-page'
                                    toggle={toogleAdminPageTooltip}
                                >
                                    Maintenance
                                </Tooltip>
                            </React.Fragment>
                        ) : null}

                        {isAdmin && inAdminPage ? (
                            <React.Fragment>
                                <Link
                                    to={'/'}
                                    id='sp-admin-page'
                                    onClick={mainPage}
                                    className='btn sp-header-login-out circle-button '
                                >
                                    <i className='fab fa-fort-awesome' />
                                </Link>

                                <Tooltip
                                    placement='bottom'
                                    isOpen={mainPageTooltipOpen}
                                    target='sp-admin-page'
                                    toggle={toogleMainPageTooltip}
                                >
                                    Main Page
                                </Tooltip>
                            </React.Fragment>
                        ) : null}

                        <Button
                            className={'d-none d-md-block'}
                            onClick={e => handleOpenEventModal(e, 'edit', 0)}
                        >
                            Create Event
                        </Button>
                        <Button
                            className='btn circle-button'
                            id='view-gallery'
                            onClick={e => gotoGallery()}
                        >
                            <i className={'far fa-images'} />
                        </Button>
                        <Tooltip
                            placement='bottom'
                            isOpen={galleryTooltipOpen}
                            target='view-gallery'
                            toggle={toogleGalleryTooltip}
                        >
                            View the events gallery
                        </Tooltip>
                        {/* <br className={'d-block d-sm-none'} /> */}
                        <Button
                            className={
                                'btn sp-body-header-going-button circle-button ' +
                                (parseInt(filter.going_to, 10) === parseInt(user_id, 10)
                                    ? 'on'
                                    : '') +
                                (inAdminPage ? ' sp-admin-hide' : '')
                            }
                            id='going-events'
                            onClick={() => {
                                scrollToFilters()
                                setFilter({
                                    going_to:
                                        parseInt(filter.going_to, 10) === parseInt(user_id, 10)
                                            ? null
                                            : user_id,
                                })
                            }}
                        >
                            <i
                                className={
                                    (parseInt(filter.going_to, 10) === parseInt(user_id, 10)
                                        ? 'fas'
                                        : 'far') + ' fa-user'
                                }
                            />
                        </Button>
                        <Tooltip
                            placement='bottom'
                            isOpen={goingTooltipOpen}
                            target='going-events'
                            toggle={toogleGoingTooltip}
                        >
                            View Events You're Going To
                        </Tooltip>

                        <Button
                            className={
                                'btn sp-body-header-like-button circle-button ' +
                                (parseInt(filter.liked_by, 10) === parseInt(user_id, 10)
                                    ? 'on'
                                    : '') +
                                (inAdminPage ? ' sp-admin-hide' : '')
                            }
                            id='liked-events'
                            onClick={() => {
                                scrollToFilters()
                                setFilter({
                                    liked_by:
                                        parseInt(filter.liked_by, 10) === parseInt(user_id, 10)
                                            ? null
                                            : user_id,
                                })
                            }}
                        >
                            <i
                                className={
                                    (parseInt(filter.liked_by, 10) === parseInt(user_id, 10)
                                        ? 'fas'
                                        : 'far') + ' fa-heart'
                                }
                            />
                        </Button>
                        <Tooltip
                            placement='bottom'
                            isOpen={likeTooltipOpen}
                            target='liked-events'
                            toggle={toogleLikeTooltip}
                        >
                            View Liked Events
                        </Tooltip>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default Header
